import React from "react";
import { Card, Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import PipelineGoalTable from "./PipelineGoalTable";
import DataTableNew from "./DataTableNew";
import SplitByTable from "./SplitByTable";

const PipelineSufficiencySection = ({ pipelineData, loading,  handleChangeLocation }) => {
  if (loading || pipelineData === "") {
    return (
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((item) => (
          <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12} key={item}>
            <Grid item xs={12} id="grid-container">
              <Grid item container component={Card} justify="center">
                <Skeleton
                  animation="wave"
                  variant="rect"
                  width="80%"
                  height={200}
                  style={{ margin: "20px 0px" }}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <>
      {/* Pipeline Goal Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Pipeline Goal
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <PipelineGoalTable
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.pipelineData}
                dataTest="PGSA-Pipeline-Goal"
                id="PSCA"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Actual Pipeline By Stage Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Actual Pipeline (By Stage)
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <DataTableNew
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.actualPipelineByStage}
                stages={pipelineData.stages}
                dataTest="PGSA-Actual-Pipeline"
                id="PSCA"
                 handleChangeLocation={handleChangeLocation}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Pipeline By Lead Source Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Pipeline By Lead Source
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <SplitByTable
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.leadSourceData}
                uniqueTypes={pipelineData.uniqueLeadSource}
                 dataTest="PGSA-Pipeline-ByLead-Source"
                type="Lead_Source"
                id="PSCA"
                firstColumnHeader="Lead Source"
                 handleChangeLocation={handleChangeLocation}
                 percentages={pipelineData.leadSourcePercentages}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Pipeline By Customer Type Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Pipeline By Customer Type
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <SplitByTable
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.custTypeData}
                uniqueTypes={pipelineData.uniqueCustType}
                 dataTest="PGSA-Pipeline-By_Cust_Type"
                type="Cust_Type"
                id="PSCA"
                firstColumnHeader="Customer Type"
                 handleChangeLocation={handleChangeLocation}
                 percentages={pipelineData.custTypePercentages}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PipelineSufficiencySection;